export const eventSelectionStatuses = ['queued', 'selected'] as const

type EventSelectionStatus = typeof eventSelectionStatuses[number]

export const eventSelectionStatusLabels: Record<EventSelectionStatus, string> =
  {
    queued: 'Benched',
    selected: 'Selected',
  }

export default EventSelectionStatus
